import { occFetch, occUrl } from "~/app/api/occ/occFetch";

type DeleteAPIParams = {
  reasonForDeletion?: string;
  improvementFeedback?: string;
};

export const deleteMyAccount = async (uid: string, data: DeleteAPIParams): Promise<Response> => {
  const response = await occFetch(occUrl(`/account/delete/${uid}`), {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Error status: " + response.status + ", please try again");
  }

  return response;
};
